// Confirmation dialog driven by the `modal` signal (see confirmDialog()).

import { modal } from '../state';
import { Button } from './Button';

export function Modal() {
  const m = modal.value;
  if (!m) return null;
  return (
    <div class="modal-backdrop layer" data-layer="modal" onClick={(e) => e.target === e.currentTarget && m.resolve(false)}>
      <div class="modal" role="alertdialog" aria-modal="true" aria-labelledby="modal-title" aria-describedby="modal-body">
        <h2 id="modal-title" class="modal-title">
          {m.title}
        </h2>
        <p id="modal-body" class="modal-body">
          {m.body}
        </p>
        <div class="modal-actions">
          <Button variant="ghost" onClick={() => m.resolve(false)} hint="ESC">
            {m.cancel}
          </Button>
          <Button variant={m.danger ? 'danger' : 'primary'} onClick={() => m.resolve(true)} autoFocus>
            {m.confirm}
          </Button>
        </div>
      </div>
    </div>
  );
}
